export default __webpack_public_path__ + "static/media/NotoSans-Medium.d230ef04.ttf";